import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Modal from '@mui/material/Modal'
import { X as XIcon } from '@phosphor-icons/react/dist/ssr/X'
import { Widget } from '@typeform/embed-react'

import { TYPEFORM_DOMAIN } from '@/lib/typeform'
import { useHideHubspotWhileMounted } from '@/hooks/use-hubspot-chat-visibility'

interface TypeformModalProps {
	open: boolean
	formId: string | null
	hidden?: Record<string, string>
	onClose: () => void
}

export function TypeformModal({ open, formId, hidden, onClose }: TypeformModalProps) {
	useHideHubspotWhileMounted(open)

	if (!formId) {
		return null
	}

	return (
		<Modal
			open={open}
			onClose={onClose}
			disableAutoFocus
			disableEnforceFocus
			disableRestoreFocus
			disableScrollLock
			sx={{ zIndex: 2147483646 }}
		>
			<Box
				sx={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					height: '100vh',
					outline: 'none',
					p: 2,
					pointerEvents: 'none',
				}}
			>
				<Box
					sx={{
						position: 'relative',
						width: 'min(900px, 100%)',
						height: 'min(720px, 100%)',
						bgcolor: 'background.paper',
						borderRadius: 1,
						boxShadow: 24,
						overflow: 'hidden',
						pointerEvents: 'auto',
					}}
				>
					<IconButton
						aria-label="Close"
						onClick={onClose}
						sx={{
							position: 'absolute',
							top: 8,
							right: 8,
							zIndex: 2,
							bgcolor: 'background.paper',
							'&:hover': { bgcolor: 'action.hover' },
						}}
					>
						<XIcon />
					</IconButton>
					{open ? (
						<Widget
							id={formId}
							domain={TYPEFORM_DOMAIN}
							hidden={hidden}
							inlineOnMobile
							style={{ width: '100%', height: '100%', border: 0 }}
						/>
					) : null}
				</Box>
			</Box>
		</Modal>
	)
}
